<div class="kanban-container" cdkDropListGroup>
  <ngx-spinner [zIndex]="100" name="spTarea" bdColor="rgba(255,255,255,0.8)" size="default"
      color="var(--primary-color)" type="ball-atom" [fullScreen]="false"></ngx-spinner>

  @for (column of columns(); track column.estadoTarea) {
  <mat-card class="kanban-column" cdkDropList [cdkDropListData]="column.tarea" (cdkDropListDropped)="drop($event)" [id]="column.estadoTarea.id" [attr.data-estado-id]="column.estadoTarea.id">
    <mat-card-header class="kanban-header">
      <div class="kanban-estadoTarea" [ngClass]="{
          'estado-pendiente': column.estadoTarea.id === estadosTareas.Pendiente,
          'estado-en-proceso': column.estadoTarea.id === estadosTareas.EnProceso,
          'estado-completada': column.estadoTarea.id=== estadosTareas.Completada,
          'estado-cerrada': column.estadoTarea.id === estadosTareas.Cerrada
        }">
        {{ column.estadoTarea.descripcion }}
      </div>
    </mat-card-header>

    <mat-card-content>
      @for (item of column.tarea; track item.id) {
      <div cdkDrag class="tarea-card mb-3">

        <div class="acciones-btn">
          <button mat-icon-button class="acciones-mini-btn" [matMenuTriggerFor]="menu" matTooltip="Acciones"
            disableRipple>
            <mat-icon fontSize="small">more_vert</mat-icon>
          </button>
        </div>

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: {item} })">
            <mat-icon>visibility</mat-icon>
            <span>Ver</span>
          </button>
          <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Modificar, entidad: {item} })">
            <mat-icon>edit</mat-icon>
            <span>Editar</span>
          </button>
          <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: {item} })">
            <mat-icon>delete</mat-icon>
            <span>Eliminar</span>
          </button>
        </mat-menu>

        <div class="font-medium text-base">Titulo: {{ item.titulo }}</div>

        <div class="asignado-linea">
          Asignado a:
          <app-avatar-iniciales [size]="'sm'" [nombre]='item.asignadoA?.nombre' [apellido]='item.asignadoA?.apellido'
            [activo]='item.asignadoA?.activo'></app-avatar-iniciales>
        </div>
        <div class="tarea-header-icons">
          <!-- Prioridad -->
          <div matTooltip="Prioridad" class="priority-badge" [ngClass]="{
                  'alta': item.prioridad === prioridadTarea.Alta,
                  'media': item.prioridad === prioridadTarea.Media,
                  'baja': item.prioridad === prioridadTarea.Baja
                }">
            <mat-icon>priority_high</mat-icon>
            {{ prioridadTarea[item.prioridad] }}
          </div>

          <div class="document-icons">
            <mat-icon class="icon-hover" [matTooltip]="'Fecha vencimiento: '+item.fechaVencimiento" *ngIf="item.fechaVencimiento"> schedule</mat-icon>
              <mat-icon  class="icon-hover" *ngIf="esHoy(item.fechaVencimiento)" [matTooltip]="'Finaliza hoy'">whatshot</mat-icon>
              <mat-icon class="icon-hover" matTooltip="Tiene expediente" *ngIf="item.expediente">gavel</mat-icon>
              <mat-icon class="icon-hover" matTooltip="Tiene notificación"
                *ngIf="item.notificado">notifications</mat-icon>
              <mat-icon class="icon-hover" matTooltip="Tiene comentario" *ngIf="item.tieneComentarios">comment</mat-icon>
          </div>
        </div>
      </div>
      }
    </mat-card-content>
  </mat-card>
  }
</div>
